module.exports = __webpack_public_path__ + "img/ems.29f59d92.jpg";